const defaultState = { access: false, activateNumberStatus: undefined };

const Inteliquent = (state = defaultState, action) => {
  switch (action.type) {
    case 'TOGGLE_PORT_ACCESS':
      return { ...state, access: action.payload };
    case 'NUMBER_ACTIVATED_ON_PORTING_TAB':
      return { ...state, activateNumberStatus: action.payload?.split('[')[1]?.split(']')[0] };
    default:
      return state;
  }
};
export default Inteliquent;
